import React from 'react';

export const CheckmarkDark = (
  <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 11.0001L0 6.00008L1.41 4.59008L5 8.17008L12.59 0.580078L14 2.00008L5 11.0001Z" fill="#1A1B22" />
  </svg>
);
